export default "/images/99ff12ad7671f41d048c9ab77821af28.avif";